<template>
  <bar :chartdata="chartdata" :options="options"/>
</template>

<script>
import Bar from '@/components/charts/bar'

export default {
  name: 'ToolsMigrated',
  components: {
    Bar
  },
  props: {
    toolsReport: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      chartdata: null,
      options: {
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              return `${tooltipItem.yLabel} accounts`
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'Accounts'
            },
            ticks: {
              beginAtZero: true
            }
          }],
          xAxes: [{
            gridLines: {
              display: false
            }
          }]
        }
      },
      tools: [
        'cfnmonitor',
        'guardian',
        'bearse',
        'bearse2',
        'ciinabox',
        'ciinabox2'
      ],
      labels: [
        'cfn-monitor',
        'guardian',
        'bearse',
        'bearse v2',
        'ciinabox',
        'ciinabox v2'
      ]
    }
  },
  methods: {
    fillchartdata: function () {
      const dataset = []
      for (const tool of this.tools) {
        if (tool in this.toolsReport) {
          var accounts = [...new Set(this.toolsReport[tool].map(item => item.account_id))]
          dataset.push(accounts.length)
        } else {
          dataset.push(0)
        }
      }

      this.chartdata = {
        labels: this.labels,
        datasets: [{
          data: dataset,
          backgroundColor: [
            '#ef476f',
            '#06d6a0',
            '#ef476f',
            '#06d6a0',
            '#ef476f',
            '#06d6a0'
          ]
        }]
      }
    }
  },
  created: function () {
    this.fillchartdata()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/ToolsMigrated.vue